module.exports = __webpack_public_path__ + "img/mercedes-sprinter.png.c857b15e.webp";